module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/vxLUAW/media/FC-9781398445055.jpg?1708094026366",
      "alt": "This image is the cover for the book Lights Camera Action"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Lights Camera Action\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("She’s an architect on top of her game, owns her own home and has a partner that equally matches her status. Bella Frederic is living the ideal success story… or is she really? When her partner Pierre Jackson finds out about her dark secret, will it destroy their perfect love? Jazz Burns may be a successful fashion designer and dresser of the stars, but she doesn’t have it together as people may think. The man she loves is not her own. Will her scandalous affair cause her to fall from the stars?")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Exquisite Charm\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Exquisite Charm fell in love with books as a teenager. In her free moments she reads whatever she gets her hands on; even if it’s just the back of a household product. Under the alias Exquisite Charm, she is pursuing her dream of being a published author. She spent four years being an inhouse staff writer for Island Publishing Limited in the Virgin Islands (British) and in her spare time when the demands of parenthood and adult life let her, she is constantly working on new stories. Her completed work can be found at: https://issuu.com/exqusitecharm")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0